import React from 'react';
import { Box, Typography } from '@mui/material';

const Link = (props) => {
    const { label, href, handleNav } = props;

    return (
        <Box>
            <Typography
                className="button-link"
                onClick={() => handleNav(href)}
                sx={{ fontSize: '13px' }}
            >
                {label}
            </Typography>
        </Box>
    );
};

export default Link;
